import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";
import burger from "../../assets/burger.png";
import DropDownMenu from "./Dropdown";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showNav, setShowNav] = useState(false);
  return (
    <div className="px-6 lg:mx-16 py-10 lg:py-6 max-md:relative">
      <div className="flex items-center justify-between">
        <Link to="/">
          <div>
            <img alt="logo" src={logo} className="w-10 lg:w-14" />
          </div>
        </Link>
        <div className="max-lg:hidden flex items-center relative border rounded-full px-10 space-x-4 text-paragraph font-medium  duration-500">
          <div
            className="cursor-pointer hover:text-primary hover:font-semibold py-2"
            onMouseEnter={() => setShowMenu(true)}
            onMouseLeave={() => setShowMenu(false)}
          >
            <h1>Products</h1>
            <div>
              <DropDownMenu show={showMenu} />
            </div>
          </div>
          <NavLink
            to="/about"
            style={({ isActive }) => ({
              color: isActive ? "#0C52CB" : "#000",
              fontWeight: isActive ? "600" : "500",
            })}
          >
            <div className="cursor-pointer hover:text-primary hover:font-semibold py-2 duration-500">
              <h1>About us</h1>
            </div>
          </NavLink>
        </div>
        <Link to="/login" className="max-lg:hidden">
          <button className="w-[150px] font-semibold">Log in</button>
        </Link>
        <div className="lg:hidden">
          <img
            alt="menu"
            src={burger}
            className="w-9 hover:cursor-pointer"
            onClick={() => setShowNav(!showNav)}
          />
        </div>
      </div>
      {showNav && (
        <div className="lg:hidden">
          <div className="absolute left-0 mt-2 w-full bg-white z-10 space-y-6 p-6 shadow-sm">
            <div className="mb-5">
              <h1 className="cursor-pointer text-primary font-semibold py-2 text-lg">
                Products
              </h1>
              <NavLink
                to="/agent-app"
                style={({ isActive }) => ({
                  color: isActive ? "#7F3DFF" : "#000",
                  fontWeight: isActive ? "600" : "400",
                  backgroundColor: isActive ? "rgb(206 220 245)" : "",
                })}
              >
                <div className="hover:bg-accent duration-500 hover:bg-opacity-30 rounded-lg p-3">
                  <h2 className="text-primaryBlack">Agent App</h2>
                  <span className="text-paragraph font-normal">
                    Streamlines transportation and logistics
                  </span>
                </div>
              </NavLink>
              <NavLink
                to="/users-app"
                style={({ isActive }) => ({
                  color: isActive ? "#7F3DFF" : "#000",
                  fontWeight: isActive ? "600" : "400",
                  backgroundColor: isActive ? "rgb(206 220 245)" : "",
                })}
              >
                <div className="hover:bg-accent duration-500 hover:bg-opacity-30 rounded-lg p-3">
                  <h2 className="text-primaryBlack">Users App</h2>
                  <span className="text-paragraph font-normal">
                    Effortlessly manage your transportation and logistics
                  </span>
                </div>
              </NavLink>
            </div>
            <div>
              <NavLink
                to="/about"
                style={({ isActive }) => ({
                  color: isActive ? "#7F3DFF" : "#000",
                  fontWeight: isActive ? "600" : "400",
                  backgroundColor: isActive ? "rgb(206 220 245)" : "",
                })}
              >
                <h1 className="cursor-pointer hover:text-primary font-medium text-paragraph duration-500 text-lg">
                  About us
                </h1>
              </NavLink>
            </div>
            <Link to="/login">
              <button className="w-full mt-6">
                <h1 className="font-semibold">Log in</h1>
              </button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
